(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("hubService", ["$timeout", "logResource", hubService]);
    //This service is the only place where we put SignalR jQuery code ($.connection...)
    //There is 2 parts: Sever->Client calls and Client->Server calls
    //Server->Client calls are registered on factory.start. It will be one function for each hub and this needs to be set before the $.connection.hub.start()
    //Client->Server calls are made in the specific service or controller that had injected the hubService. Use hubService.server.hubName.serverFunction(params).
    //Don't forget to add your hub to the factory.server at the end.
    function hubService($timeout, logResource) {
        var factory = {
            isConnected: false,
            disconnectedCount: 0
        };
        //var callbackList = {};
        ////#region Register functions for all Hubs
        ////function registerAdminNotificationHub() {
        ////	console.log("[hubService] registerAdminNotificationHub");
        ////	$.connection.adminNotificationHub.client.onAssignmentMapQueueChange = function (result) {
        ////		console.log("[hubService] onAssignmentMapQueueChange");
        ////		invokeCallbackList("adminNotificationHub", "onAssignmentMapQueueChange", [result]);
        ////	};
        ////}
        //function registerUserHub() {
        //	console.log("[hubService] registerUserHub");
        //	$.connection.userHub.client.onDisconnect = function (result) {
        //		console.log("[hubService] onDisconnect");
        //		invokeCallbackList("userHub", "onDisconnect", [result]);
        //	};
        //	$.connection.userHub.client.onRefreshUserNotifications = function (result) {
        //		console.log("[hubService] onRefreshUserNotifications");
        //		invokeCallbackList("userHub", "onRefreshUserNotifications", [result]);
        //	};
        //	$.connection.userHub.client.onRefreshLearningPath = function (result) {
        //		console.log("[hubService] onRefreshLearningPath");
        //		invokeCallbackList("userHub", "onRefreshLearningPath", [result]);
        //	};
        //	$.connection.userHub.client.onRefreshLearningPlan = function (result) {
        //		console.log("[hubService] onRefreshLearningPlan");
        //		invokeCallbackList("userHub", "onRefreshLearningPlan", [result]);
        //	};
        //	$.connection.userHub.client.onRefreshCheckout = function (result) {
        //		console.log("[hubService] onRefreshCheckout");
        //		invokeCallbackList("userHub", "onRefreshCheckout", [result]);
        //	};
        //	$.connection.userHub.client.onUserSignedIn = function (result) {
        //		console.log("[hubService] onUserSignedIn");
        //		invokeCallbackList("userHub", "onUserSignedIn", [result]);
        //	};
        //	$.connection.userHub.client.onUserSignedOut = function (result) {
        //		console.log("[hubService] onUserSignedOut");
        //		invokeCallbackList("userHub", "onUserSignedOut", [result]);
        //	};
        //	$.connection.userHub.client.onShowPointsCollectedNotification = function (result) {
        //		console.log("[hubService] onShowPointsCollectedNotification");
        //		invokeCallbackList("userHub", "onShowPointsCollectedNotification", [result]);
        //	};
        //	$.connection.userHub.client.onShowTierAchievedNotification = function (result) {
        //		invokeCallbackList("userHub", "onShowTierAchievedNotification", [result]);
        //	};
        //}
        ////#endregion
        ////#region Private
        //function invokeCallbackList(hubName, methodName, params) {
        //	console.log("[hubService] invokeCallbackList(" + hubName + ", " + methodName + ", " + params + ")");
        //	if (!callbackList[hubName] || !callbackList[hubName][methodName]) {
        //		console.log("[hubService] invokeCallbackList(" + hubName + ", " + methodName + ", " + params + ") - NOT found");
        //		return;
        //	}
        //	console.log("[hubService] invokeCallbackList(" + hubName + ", " + methodName + ", " + params + ") - found");
        //	for (var i in callbackList[hubName][methodName]) {
        //		if (callbackList[hubName][methodName].hasOwnProperty(i)) {
        //			callbackList[hubName][methodName][i].apply(this, params);
        //		}
        //	}
        //}
        ////#endregion
        ////#region Manage SignalR Connections
        //var tryingToReconnect = false;
        //var stopCalled = false;
        //$.connection.hub.reconnecting(function () {
        //	console.log("[hubService] hub reconnecting");
        //	tryingToReconnect = true;
        //});
        //$.connection.hub.reconnected(function () {
        //	console.log("[hubService] hub reconnected");
        //	tryingToReconnect = false;
        //	factory.isConnected = true;
        //});
        //$.connection.hub.disconnected(function () {
        //	factory.isConnected = false;
        //	factory.disconnectedCount += 1;
        //	if ($.connection.hub.lastError) {
        //		//var lastError = $.connection.hub.lastError.message;
        //		//if (lastError.indexOf("Failed at parsing response") > -1)
        //		//	lastError = "Failed at parsing response: SIGNALR PROBABLY";
        //		console.log("[hubService] hub disconnected with error. Reason: " + $.connection.hub.lastError.message);
        //		//logResource.logError({ value: `[hubService] hub disconnected with error. Count: ${factory.disconnectedCount} Reason: ${lastError}` }).$promise.catch(angular.noop);
        //	} else {
        //		console.log("[hubService] hub disconnected without error.");
        //	}
        //	if (stopCalled) {
        //		stopCalled = false;
        //		console.log("[hubService] hub disconnected - stop called");
        //		return;
        //	}
        //	if (factory.disconnectedCount <= 10) {
        //		$timeout(function () {
        //			if (!tryingToReconnect && !factory.isConnected) {
        //				console.log("[hubService] hub disconnected - starting factory again");
        //				factory.start();
        //			}
        //		}, 60000);
        //	}
        //});
        ////#endregion
        //factory.addCallback = function (hubName, methodName, callback) {
        //	console.log("[hubService] addCallback(" + hubName + ", " + methodName + ")");
        //	if (!callbackList[hubName])
        //		callbackList[hubName] = {};
        //	if (!callbackList[hubName][methodName] || callbackList[hubName][methodName].length === 0) {
        //		//each method has a single call back, if not in the call back list add it
        //		callbackList[hubName][methodName] = [];
        //		callbackList[hubName][methodName].push(callback);
        //	}
        //	//Return a function to remove the item from the callback list
        //	return function () {
        //		if (callbackList[hubName] && callbackList[hubName][methodName])
        //			callbackList[hubName][methodName].splice(callbackList[hubName][methodName].indexOf(callback));
        //	};
        //};
        //factory.start = function (authentication, callback) {
        //	if (authentication)
        //		factory.userEmail = authentication.userEmail;
        //	console.log("[hubService] start");
        //	//Register all callback functions
        //	//DotNet6 fix commented out  code
        //	registerUserHub();
        //	$.connection.hub.error(function (error) {
        //		console.log("[hubService] connection.hub.error: " + error);
        //	});
        //	$.connection.hub.logging = true;
        //	$timeout(function () {
        //		$.connection.hub.start({ transport: ["webSockets", "serverSentEvents", "foreverFrame"] }).done(function () {
        //			factory.isConnected = true;
        //			factory.disconnectedCount = 0;
        //			console.log("[hubService] start success, transport = " + $.connection.hub.transport.name);
        //			if (callback)
        //				callback();
        //		}).fail(function (error) {
        //			factory.isConnected = false;
        //			console.error("[hubService] start fail: Unable to Connect: User agent: " + navigator.userAgent + " [error]: " + error);
        //			logResource.logError({ value: "[SIGNALR] Unable to Connect: Email: " + factory.userEmail + " [error]: " + error + ", User agent: " + navigator.userAgent }).$promise.catch(angular.noop);
        //		});
        //	}, 500);
        //};
        //factory.stop = function (callback) {
        //	stopCalled = true;
        //	$.connection.hub.stop();
        //	callbackList = {};
        //	factory.isConnected = false;
        //	factory.disconnectedCount = 0;
        //	if (callback)
        //		callback();
        //};
        ////For each hub add the server variable here
        //factory.server = {
        //	//DotNet6 fix
        //	userHub: $.connection.userHub.server
        //};
        return factory;
    }
}());
